/**
 * eBay SOLD-listings deep link — the free, ToS-clean way to see real recent
 * sale prices. Opens eBay's sold/completed search for the lot, sorted newest
 * first (_sop=13). On a phone this lands in the eBay app, which makes it the
 * on-the-go comp check for vendors. (In-app sold DATA would require either
 * eBay's partner-restricted Marketplace Insights API or a paid scraper —
 * evaluated 2026-07-10 and deliberately deferred.)
 */
import { DB } from "./db";
import { toast } from "./dom";

export function openEbaySoldsFor(kind: "card" | "sealed", lotId: string): void {
  const table = kind === "card" ? "cards" : "sealed";
  const key = kind === "card" ? "Card Lot ID" : "Lot ID";
  const r = DB.table(table).find(x => x[key] === lotId);
  if (!r) { toast("Lot not found", "err"); return; }

  let q: string;
  if (kind === "card") {
    // Slabs: include the grade — "PSA 10" comps are a different market than raw.
    const grade = String(r["Condition/Grade"] || "").trim();
    const isGrade = /^(PSA|BGS|CGC|SGC|TAG)\b/i.test(grade);
    q = [r["Card Name"], r["Set"], r["Card #"], isGrade ? grade : ""]
      .map(v => String(v || "").trim()).filter(Boolean).join(" ");
  } else {
    // Catalog product names usually already contain the set; prepend it only
    // when they don't.
    q = String(r["Product"] || "").trim();
    const set = String(r["Set"] || "").trim();
    if (q && set && !q.toLowerCase().includes(set.toLowerCase())) q = `${set} ${q}`;
  }
  if (!q) { toast("No item info to search.", "err"); return; }

  const url = "https://www.ebay.com/sch/i.html?_nkw=" + encodeURIComponent(q)
    + "&LH_Sold=1&LH_Complete=1&_sop=13";
  window.open(url, "_blank", "noopener");
}
(window as any).openEbaySoldsFor = openEbaySoldsFor;
